import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';

const TracsessTunePrivacyPolicy: React.FC = () => {
  return (
    <PrivacyPolicy
      appName="Tracsess Tune"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/tune/PP_Tracsess_Tune.pdf"
      title="Tracsess Tune Privacy Policy"
    />
  );
};

export default TracsessTunePrivacyPolicy; 